'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var _reduxConnect = require('redux-connect');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GETTING_READY = 'module0';
var MODULE_1 = 'module1';
var MODULE_2 = 'module2';
var MODULE_3 = 'module3';
var MODULE_4 = 'module4';
var MODULE_5 = 'module5';

var Modules = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!(0, _moduleData.isLoaded)(getState())) {
      var userId = getState().auth.user.userId;
      promises.push(dispatch((0, _moduleData.loadAllModules)(userId)));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, app: state.moduleData.data, userIsAdmin: state.userCredential };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Modules, _Component);

  function Modules() {
    (0, _classCallCheck3.default)(this, Modules);
    return (0, _possibleConstructorReturn3.default)(this, (Modules.__proto__ || (0, _getPrototypeOf2.default)(Modules)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modules, [{
    key: 'render',
    value: function render() {
      var style = require('./ModulesLanding.scss');
      var module0 = require('./module0.png');
      var module1 = require('./module1.png'); // why are healthy habits important for children after cancer treatment
      var module2 = require('./module2.png'); // the home environment
      var module3 = require('./module3.png'); // encouraging children to eat vegetables
      var module4 = require('./module4.png'); // summary and planning for the future
      var boostermodule = require('./boostermodule.png'); // continuing progress after reboot kids

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Modules' }),
        _react2.default.createElement(
          'div',
          { className: style.title },
          _react2.default.createElement(
            'h1',
            null,
            'Modules'
          )
        ),
        _react2.default.createElement(
          ReactBootstrap.Grid,
          null,
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              'div',
              { className: style.section },
              _react2.default.createElement(
                ReactBootstrap.Row,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 6, sm: 6, xs: 12 },
                  _react2.default.createElement(_components.ModuleItem, { moduleTitle: 'Module 1', moduleImg: module1, moduleID: MODULE_1,
                    moduleDescription: 'Healthy eating habits', isLocked: false })
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 6, sm: 6, xs: 12 },
                  _react2.default.createElement(_components.ModuleItem, { moduleTitle: 'Module 2', moduleImg: module2, moduleID: MODULE_2,
                    moduleDescription: 'Home food environment', isLocked: false })
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 6, sm: 6, xs: 12 },
                  _react2.default.createElement(_components.ModuleItem, { moduleTitle: 'Module 3', moduleImg: module3, moduleID: MODULE_3,
                    moduleDescription: 'Encouraging vegetables', isLocked: false })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Modules;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object,
  userIsAdmin: _propTypes2.default.object
}, _temp)) || _class) || _class);

/* eslint-enable */

exports.default = Modules;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ModulesLanding/ModulesLanding.js
// module id = 1282
// module chunks = 0